const UNSET_RISK_LEVELS = ['', 'na', 'n/a'];

const isSetRiskLevel = (value?: string | null): value is string =>
  typeof value === 'string' &&
  !UNSET_RISK_LEVELS.includes(value.trim().toLowerCase());

/**
 * Risk level the slide-out shows for a phase or moment: its own value, else the card-level
 * value, else Low. The icon and the dropdown checkmark both read this so they never disagree —
 * PCO phases created without a riskLevel showed the Low icon with nothing checked (CSME-118361).
 *
 * @param ownRiskLevel - The phase's (or non-phased moment's) generalInfo.riskLevel
 * @param cardRiskLevel - The card-level (moment root) riskLevel
 * @returns The stored spelling of the first set value (e.g. 'Green' or 'Low'), else 'Low'
 * @example resolveRiskLevel('', 'High') // 'High'
 */
export const resolveRiskLevel = (
  ownRiskLevel?: string | null,
  cardRiskLevel?: string | null
): string => {
  if (isSetRiskLevel(ownRiskLevel)) return ownRiskLevel;
  if (isSetRiskLevel(cardRiskLevel)) return cardRiskLevel;
  return 'Low';
};
